import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const checkboxLabelFn = /* @__PURE__ */ createRecipe('checkbox-label', {
  "size": "l",
  "color": "neutral",
  "weight": "medium"
}, [])

const checkboxLabelVariantMap = {
  "size": [
    "l",
    "m"
  ],
  "display": [
    "desktop"
  ],
  "color": [
    "neutral",
    "primary"
  ],
  "weight": [
    "medium",
    "bold"
  ]
}

const checkboxLabelVariantKeys = Object.keys(checkboxLabelVariantMap)

export const checkboxLabel = /* @__PURE__ */ Object.assign(memo(checkboxLabelFn.recipeFn), {
  __recipe__: true,
  __name__: 'checkboxLabel',
  __getCompoundVariantCss__: checkboxLabelFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: checkboxLabelVariantKeys,
  variantMap: checkboxLabelVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, checkboxLabelVariantKeys)
  },
  getVariantProps: checkboxLabelFn.getVariantProps,
})